import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ChatView from '@views/chat/ChatView';

export default class Chat extends AbstractController {
    protected controllerName = 'Comments';

    protected availableActions = [
        'index',
    ];
    protected actionsComponents = {
        index: ChatView,
    };
}
